export const primaryColor = '#DDE4E6'
